module.exports = __webpack_public_path__ + "img/1.275c2e1a.png";